import { CreateTRPCClient, createTRPCClient, httpBatchLink } from '@trpc/client'
import { AppRouter } from '../../src/server'

declare global {
	interface Window {
		api: CreateTRPCClient<AppRouter>;
		baseUrl: string
		tabler: any
	}
}

//@ts-ignore
if (import.meta.hot) {
	//@ts-ignore
	import.meta.hot.accept()
}

window.baseUrl = window.location.protocol + '//' + window.location.host

const api = createTRPCClient<AppRouter>({
	links: [
		httpBatchLink({
			url: `${window.baseUrl}/api/v2`,
		}),
	],
});

window.api = api;

import './components/2FA.svelte'
import './components/Login.svelte'
import './components/Auth.svelte'
import './components/Landing.svelte'
import './components/Admin.svelte'
import './components/admin/Acl/Scopes.svelte'